/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ImageSeriesList from './ImageSeriesList/index'
import Images from './Images/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/ImageSeries/Body/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientDocumentsSelectedImageSeriesValueData = fromData.useDataFormat({ viewPath,
context: 'patient_documents',
path: 'selected_image_series',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: patientDocumentsSelectedImageSeriesValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImageSeriesList'}>
<ImageSeriesList
  viewPath={`${viewPath}/ImageSeriesList`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Images'}>
<Images
  viewPath={`${viewPath}/Images`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}